import { render, staticRenderFns } from "./BaseHeaderReservationRequestCount.vue?vue&type=template&id=710e279c&scoped=true&"
import script from "./BaseHeaderReservationRequestCount.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderReservationRequestCount.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderReservationRequestCount.vue?vue&type=style&index=0&id=710e279c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e279c",
  null
  
)

export default component.exports